import { render } from "./QuestPuzzle.vue?vue&type=template&id=1306dd07"
import script from "./QuestPuzzle.vue?vue&type=script&lang=js"
export * from "./QuestPuzzle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/QuestPuzzle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1306dd07"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1306dd07', __exports__)) {
    api.reload('1306dd07', __exports__)
  }
  
  module.hot.accept("./QuestPuzzle.vue?vue&type=template&id=1306dd07", () => {
    api.rerender('1306dd07', render)
  })

}


export default __exports__